"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_ACCESS_DELAY = 1000;
function cacheCookieAccess(name) {
    var timeout;
    var cache;
    var hasCache = false;
    var cacheAccess = function () {
        hasCache = true;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(function () {
            hasCache = false;
        }, exports.COOKIE_ACCESS_DELAY);
    };
    return {
        get: function () {
            if (hasCache) {
                return cache;
            }
            cache = getCookie(name);
            cacheAccess();
            return cache;
        },
        set: function (value, expireDelay) {
            setCookie(name, value, expireDelay);
            cache = value;
            cacheAccess();
        },
    };
}
exports.cacheCookieAccess = cacheCookieAccess;
function setCookie(name, value, expireDelay) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/;samesite=strict";
}
exports.setCookie = setCookie;
function getCookie(name) {
    var matches = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return matches ? matches.pop() : undefined;
}
exports.getCookie = getCookie;
function areCookiesAuthorized() {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        var testCookieName = 'dd_rum_test';
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, 1000);
        return getCookie(testCookieName) === testCookieValue;
    }
    catch (error) {
        console.error(error);
        return false;
    }
}
exports.areCookiesAuthorized = areCookiesAuthorized;
//# sourceMappingURL=cookie.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-core/cjs/cookie.js
// module id = 184
// module chunks = 0